import htmlModules from './html-modules/html-modules';

var node = document.createElement("DIV");

node.innerHTML=`
<div class="gears-interactive-app">
    <div id="myModal" class="modal">
        <!-- Modal welcome -->
        ${htmlModules.modalWelcome}
        <!-- Modal Info of the info box strong text -->
        ${htmlModules.modalInfo}
        <!-- Modal window width -->
        ${htmlModules.modalWidth}
        <!-- Modal glossary width -->
        ${htmlModules.modalGlossary}
    </div></div></div>
    <div class="main-container">

    <!-- ***** Canvas is not being used for now
    <canvas id="myCanvas" width="1024" height="768" style="border:0px solid #d3d3d3; position: absolute;">
    Your browser does not support the HTML5 canvas tag.
    </canvas>
    -->
    
        <div class="container_view">
        <img src="./assets/images/E3_Logo_Type_Tag_RGB_v2.png" style="position: absolute; left: 20px; width: 250px; top: 530px;">
            <!-- animated gears section -->
            ${htmlModules.gearsSection}
            <!-- information box -->
            ${htmlModules.infoCenter}
            <!-- options box per gear-->
            ${htmlModules.optionsBox}
            <!-- side bar controls nav -->
            ${htmlModules.sideBarNav}
        </div>
        <div class="container_controls">
            <!-- controls panel - where all the conditions and threatments buttons are -->
            ${htmlModules.controlsPanel}
        </div>
    </div>
</div>
<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/1.20.3/TweenMax.min.js"></script>
`;

document.querySelector('body').appendChild(node);


// WEBPACK FOOTER //
// ./src/js/html.js